import TextField from "@components/atoms/input";
import Box from "@mui/material/Box";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import React, { useEffect, useRef, useState } from "react";

import {
  Option,
  OptionWrapper,
  SubOption,
  SuggestionList,
  SuggestionWrapper,
} from "./locationSearchBox.styled";
import { SuggestionProps } from "./locationSearchBox.type";

type LocationSearchBoxProps = {
  isUI?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  label?: string;
  name?: string;
  type?: string;
  placeholder?: string;
  color?: string;
  value: string;
  touched?: boolean;
  error?: boolean;
  multiline?: boolean;
  data: SuggestionProps[];
  rows?: number;
  errorMessage?: string;
  onSuggestionClick: (arg: any) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

const LocationSearchBox = ({
  errorMessage,
  label,
  name,
  onBlur,
  onChange,
  data,
  placeholder,
  onSuggestionClick,
  touched,
  value,
}: LocationSearchBoxProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    if (data?.length) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [data]);

  const optionItemRender = (location: SuggestionProps) => (
    <>
      <OptionWrapper
        onClick={() => {
          onSuggestionClick(location);
          setIsVisible(false);
        }}
      >
        <Option>{location?.name}</Option>
        <SubOption>
          {location?.full_address ? location?.full_address : ""}
        </SubOption>
      </OptionWrapper>
    </>
  );

  return (
    <ClickAwayListener onClickAway={() => setIsVisible(false)}>
      <Box sx={{ position: "relative" }}>
        <TextField
          placeholder={placeholder}
          name={name}
          fullWidth
          label={label}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          errorMessage={errorMessage}
          touched={touched}
        />
        {isVisible && (
          <SuggestionWrapper>
            <SuggestionList>
              {data?.map((location: SuggestionProps, index: number) => (
                <React.Fragment key={index}>
                  {optionItemRender(location)}
                </React.Fragment>
              ))}
            </SuggestionList>
          </SuggestionWrapper>
        )}
      </Box>
    </ClickAwayListener>
  );
};

export default LocationSearchBox;
